module.exports = __webpack_public_path__ + "static/online-program-fast-track-ffa7a0c4edb4d55ec864f7c47c42f07b.png";